import React from 'react';
import ExpenseObligationWorkspace from './ExpenseObligationWorkspace';

/** 원인행위등록 */
export default function ExpenseObligationRegister() {
  return <ExpenseObligationWorkspace screenMode="register" />;
}
